import React, {useEffect, useState} from 'react';

// components
import Loader from "../../Container/Loader";

// -- redux
import {connect} from "react-redux";
import {Registration, EditRegistration} from "../../Redux/Actions/SignupAction"

function Signup(props) {

    const [id, setID] = useState('');
    const [URL, setURL] = useState('');
    const [hide, setHide] = useState('');
    const [URLError, setURLError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        let expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
        let regex = new RegExp(expression);
        let expressionHttps = /^https:\/\//;
        let regexHttps = new RegExp(expressionHttps);
        if (URL.match(regex) && URL.match(regexHttps)) {
            setURLError('');
            const data = {
                id: id,
                url: URL
            };
            props.EditRegistration(data)
        }else {
            setURLError('Invalid URL');
        }
    };

    useEffect(() => {
        props.Registration();
        setHide(true)
    }, [props.edit_data]);

    useEffect(() => {
        if(props.get_data.status === 200){
            props.get_data.data.map((data) => {
                setID(data.id);
                setURL(data.url)
            });
            setTimeout(function () {
                setHide(false)
            }, 2000)
        }
    }, [props.get_data, props.edit_data]);

    return (
        <>
            {props.loading && <Loader/>}
            <div className='ml-4 mr-4 mt-5'>
                <label className='text-grey-6 f-16 d-block mb-1'>Search URL</label>
                <input
                    type='text'
                    placeholder='Enter search URL'
                    className='w-100'
                    onChange={(e) => setURL(e.target.value)}
                    value={URL}
                />
                {URLError && <p className='f-12 text-danger'>{URLError}</p>}
                <div className='d-flex justify-content-between mt-5'>
                    {/* <button className='form-button' disabled={!URL}  onClick={() => setURL('')}>Cancel</button> */}
                    <button className='form-button' disabled={!URL} onClick={(e) => handleSubmit(e)}>Save</button>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = ({RegistrationReducer}) => {
    const {loading, get_data, edit_data} = RegistrationReducer;
    return {loading, get_data, edit_data}
};

const mapDispatchToProps = {
    Registration,
    EditRegistration
};

export default connect(mapStateToProps, mapDispatchToProps)(Signup)